import { render, staticRenderFns } from "./DescriptionDetail.vue?vue&type=template&id=383a7297&"
import script from "./DescriptionDetail.vue?vue&type=script&lang=js&"
export * from "./DescriptionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports